import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatRadioChange } from '@angular/material'

@Component({
  selector: 'bra-radio',
  templateUrl: './bra-radio.component.html',
  styleUrls: ['./bra-radio.component.css']
})
export class BraRadioComponent implements OnInit {

  public max: number = 9;

  shouldRender: boolean;
  selectedOption;

  @Input()
  options;

  @Output()
  valueChange = new EventEmitter<string>();

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  constructor() { }

  ngOnInit() {
    this.shouldRender = this.options.length > 0;
    this.selectedOption = this.options.find(option => option.default);
  }

  onValueChange(event: MatRadioChange) {
    this.valueChange.emit(event.value.value);
  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-radio/bra-radio.component.ts